/* eslint-disable no-console */
import Konva from 'konva'
import LayoutGreenScreen from "@/layouts/green-screen/layout-green-screen.vue"
import oButton from "@/objects/o-button/o-button.vue"
import oModal from "@/objects/o-modal/o-modal.vue"

export default {
  name: "vTestTouch",
  components: {
    "layout-green-screen": LayoutGreenScreen,
    "o-button": oButton,
    "o-modal": oModal
  },
  data() {
    return {
      stage: null,
      layerDrawing: null,
      width: null,
      height: null,
      canvasWidth: null,
      canvasHeight: null,
      imageWidth: null,
      imageHeight: null
    }
  },
  methods: {
    start() {
      this.inProgress = true;

      Konva.hitOnDragEnabled = true;
      Konva.captureTouchEventsEnabled = true;

      this.initializeCanvas(this.$store.getters.currentDrawing);
    },
    cleanUp() {
      // clean up canvas
      this.stage = null;
      this.layer = null;

      const canvas = document.getElementById('container-canvas');
      canvas.innerHTML = '';
    },
    initializeCanvas(src) {
      const _this = this;

      this.stage = new Konva.Stage({
        container: 'container-canvas',
        width: this.canvasWidth,
        height: this.canvasHeight
      });

      this.layerDrawing = new Konva.Layer();
      this.stage.add(this.layerDrawing);

      // drawing
      let drawing = new Konva.Image({
        width: this.imageWidth,
        height: this.imageHeight
      });

      let drawingGroup = new Konva.Group({
        x: 180,
        y: 50,
        draggable: true
      });
      this.layerDrawing.add(drawingGroup);
      drawingGroup.add(drawing);
      this.addLine(drawingGroup, 0, 0, this.imageWidth, 0, 'lineTop');
      this.addLine(drawingGroup, this.imageWidth, 0, this.imageWidth, this.imageHeight, 'lineRight');
      this.addLine(drawingGroup, 0, this.imageHeight, this.imageWidth, this.imageHeight, 'lineBottom');
      this.addLine(drawingGroup, 0, 0, 0, this.imageHeight, 'lineLeft');
      this.addAnchor(drawingGroup, 0, 0, 'topLeft');
      this.addAnchor(drawingGroup, this.imageWidth, 0, 'topRight');
      this.addAnchor(drawingGroup, this.imageWidth, this.imageHeight, 'bottomRight');
      this.addAnchor(drawingGroup, 0, this.imageHeight, 'bottomLeft');

      // eslint-disable-next-line no-undef, no-unused-vars
      let hammertime = new Hammer(drawingGroup, { domEvents: true });

      let imageObj = new Image();
      imageObj.onload = function () {
        drawing.image(imageObj);
        _this.layerDrawing.draw();
      };
      // 'https://www.w3schools.com/w3css/img_lights.jpg'
      imageObj.crossOrigin = 'Anonymous';
      imageObj.src = src;
    },
    update(activeAnchor) {
      let group = activeAnchor.getParent();

      let topLeft = group.find('.topLeft')[0];
      let topRight = group.find('.topRight')[0];
      let bottomRight = group.find('.bottomRight')[0];
      let bottomLeft = group.find('.bottomLeft')[0];
      let lineTop = group.find('.lineTop')[0];
      let lineRight = group.find('.lineRight')[0];
      let lineBottom = group.find('.lineBottom')[0];
      let lineLeft = group.find('.lineLeft')[0];
      let image = group.find('Image')[0];

      let anchorX = activeAnchor.getX();
      let anchorY = activeAnchor.getY();

      // update anchor positions
      switch (activeAnchor.getName()) {
        case 'topLeft':
          topRight.y(anchorY);
          bottomLeft.x(anchorX);
          break;
        case 'topRight':
          topLeft.y(anchorY);
          bottomRight.x(anchorX);
          break;
        case 'bottomRight':
          bottomLeft.y(anchorY);
          topRight.x(anchorX);
          break;
        case 'bottomLeft':
          bottomRight.y(anchorY);
          topLeft.x(anchorX);
          break;
      }

      lineTop.points([topLeft.getX(), topLeft.getY(), topRight.getX(), topRight.getY()]);
      lineRight.points([topRight.getX(), topRight.getY(), bottomRight.getX(), bottomRight.getY()]);
      lineBottom.points([bottomLeft.getX(), bottomLeft.getY(), bottomRight.getX(), bottomRight.getY()]);
      lineLeft.points([topLeft.getX(), topLeft.getY(), bottomLeft.getX(), bottomLeft.getY()]);

      image.position(topLeft.position());

      let width = topRight.getX() - topLeft.getX();
      let height = bottomLeft.getY() - topLeft.getY();
      if (width && height) {
        image.width(width);
        image.height(height);
      }
    },
    addAnchor(group, x, y, name) {
      const _this = this;

      let layer = group.getLayer();

      let anchor = new Konva.Circle({
        x: x,
        y: y,
        stroke: '#003865',
        fill: '#003865',
        strokeWidth: 2,
        radius: 8,
        name: name,
        draggable: true,
        dragOnTop: false
      });

      anchor.on('dragmove', function () {
        _this.update(this);
        layer.draw();
      });
      anchor.on('mousedown touchstart', function () {
        group.draggable(false);
        this.moveToTop();
      });
      anchor.on('dragend', function () {
        group.draggable(true);
        layer.draw();
      });
      anchor.on('swipe', function (ev) {
        group.to({
          x: group.x() + ev.evt.gesture.deltaX,
          y: group.y() + ev.evt.gesture.deltaY
        });
      });

      group.add(anchor);
    },
    addLine(group, x_start, y_start, x_end, y_end, name) {
      let line = new Konva.Line({
        points: [x_start, y_start, x_end, y_end],
        stroke: '#EFEFEF',
        strokeWidth: 4,
        lineJoin: 'round',
        dash: [20, 10],
        draggable: true,
        dragOnTop: false,
        name: name
      });

      group.add(line);
    },
    setDimensions() {
      this.canvasWidth = window.innerWidth;
      this.canvasHeight = window.innerHeight - 120;
      this.imageWidth = 1024;
      this.imageHeight = 768;
    }
  },
  computed: {
    hasDrawings() {
      return this.$store.getters.hasDrawings;
    },
    drawings() {
      return this.$store.state.drawings;
    }
  },
  watch: {
    drawings(arr) {
      // If drawings are added => check if the process needs to start
      if(!this.inProgress && arr.length > 0) {
        this.$nextTick(() => {
          this.start();
        })
      }
    }
  },
  mounted() {
    this.setDimensions();

    if(this.$store.getters.hasDrawings) {
      this.$nextTick(() => {
        this.cleanUp();
        this.start();
      })
    }
  }
}
